/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';

import IntlMessageComponent from 'components/formatters/intlMessage';

type FilterTextComponentProps = {
  filterId: string;
  label: string;
  value: string;
  selectFilter: (filterId: string, value: string) => void;
}

export default function FilterTextComponent(props: FilterTextComponentProps) {

  const handleChange = (event: SyntheticInputEvent<HTMLInputElement>) =>
    props.selectFilter(props.filterId, event.target.value);

  // same structure as the dropdown filters (components/isoFilters/iso.js) so the rows line up
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        <b><IntlMessageComponent id={props.label} /></b>
      </FormLabel>
      <Box mb={5}>
        <TextField
          id={props.filterId}
          style={{minWidth: "15vw", maxWidth: "15vw"}}
          value={props.value}
          onChange={handleChange}
        />
      </Box>
    </FormControl>
  );
}
